const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getBaseUrl = () => {
  if (!API_BASE_URL) {
    throw new Error('API base URL is not configured. Please set REACT_APP_API_BASE_URL.');
  }
  return API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL;
};

const handleResponse = async (response) => {
  const json = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message = json?.message || `HTTP ${response.status}`;
    throw new Error(message);
  }
  if (json && json.success === false) {
    throw new Error(json?.message || 'API responded with an error.');
  }
  return json;
};

export const customerService = {
  async getCustomers(customerId = null, search = '') {
    const base = getBaseUrl();
    const token = localStorage.getItem('token');
    let url = customerId 
      ? `${base}/api/customers/${customerId}`
      : `${base}/api/customers`;
    
    // Add search parameter if provided and not fetching single customer
    if (!customerId && search) {
      const params = new URLSearchParams({ filterKey: search });
      url = `${url}?${params.toString()}`;
    }
    
    const response = await fetch(url, {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    const json = await handleResponse(response);
    // If customerId is provided, return single customer object, otherwise return array
    return customerId ? json?.data : (Array.isArray(json?.data) ? json.data : []);
  },

  async createCustomer(payload) {
    const base = getBaseUrl();
    const token = localStorage.getItem('token');
    const response = await fetch(`${base}/api/customers`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(payload),
    });
    const json = await handleResponse(response);
    return json?.data;
  },

  async updateCustomer(id, payload) {
    if (!id) {
      throw new Error('Customer id is required for update');
    }
    const base = getBaseUrl();
    const token = localStorage.getItem('token');
    const response = await fetch(`${base}/api/customers/${id}`, {
      method: 'PUT',
      headers: { 
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(payload),
    });
    const json = await handleResponse(response);
    return json?.data;
  },

  async deleteCustomer(id) {
    if (!id) {
      throw new Error('Customer id is required for deletion');
    }
    const base = getBaseUrl();
    const token = localStorage.getItem('token');
    const response = await fetch(`${base}/api/customers/${id}`, {
      method: 'PUT',
      headers: { 
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ isDeleted: true }),
    });
    const json = await handleResponse(response);
    return json?.data;
  },

  async verifyCustomerByPhone(phone) {
    if (!phone) {
      throw new Error('Phone number is required for verification');
    }
    const base = getBaseUrl();
    const token = localStorage.getItem('token');
    const response = await fetch(`${base}/api/customers/verifyByPhone?phone=${encodeURIComponent(phone)}`, {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });

    // Handle both successful and not found responses
    const json = await response.json().catch(() => ({}));

    if (response.ok && json?.status === true && json?.data) {
      // User exists - return customer data with userExist flag
      return {
        userExist: true,
        ...json.data
      };
    } else if (response.status === 404 || (json?.status === false && json?.message?.includes('not found'))) {
      // User doesn't exist - return flag indicating manual entry needed
      return {
        userExist: false,
        phone: phone // Keep the phone number for reference
      };
    } else {
      // Other errors
      const message = json?.message || `HTTP ${response.status}`;
      throw new Error(message);
    }
  },
};


